/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { LazyHorizontalNavQueue } from '@jira/navigation-apps__horizontal-nav-jsm-queue/src/async-for-paint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import {
	getRapidBoardDataResource,
	getRapidboardResources,
} from '@jira/router-resources__classic-projects/src/getRapidboardResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getQueuesResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { uifBoardResource } from '@jira/router-resources__uif-board/src/uifBoardResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { customPracticeQueueBoardRoute } from '@jira/router-routes__servicedesk-queue-routes/src/customPracticeQueueBoardRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { BoardSkeleton, boardPageEntryPoint } from './ui/board/index.tsx';

export const customPracticeQueueBoardRouteEntry: Route = createEntry(
	customPracticeQueueBoardRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint: () => boardPageEntryPoint,
		layout: serviceProjectLayout,
		skeleton: BoardSkeleton,
		navigation: {
			menuId: MenuIdProjects,
		},
		resources: [
			...getQueuesResources(),
			getConsolidationStateResource(),
			...getRapidboardResources(),
			getRapidBoardDataResource(),
			resourceWithCondition(() => !__SERVER__, uifBoardResource),
		],
		forPaint: [LazyAtlassianNavigation, LazyHorizontalNavQueue],
		supportsPreviewPanel: true,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
